import { render, staticRenderFns } from "./HistoricRecord.vue?vue&type=template&id=7da47ae1"
import script from "./HistoricRecord.vue?vue&type=script&lang=js"
export * from "./HistoricRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports